// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3q3z1","delete":"styles_delete__3g7oM","update":"styles_update__V5_l4","add":"styles_add__18RAS"};